module.exports = __webpack_public_path__ + "static/media/deletedsurveysuccessful.e7145e4c.svg";